TYPE_STATIC_WHITE